import { call, put } from "redux-saga/effects";
import { apiRouting, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListPickingQuarentinesActions } from "store/ducks/picking-quarentines";

export function* listPickingQuarentinesRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiRouting.get, `/picking-quarentines-scheduling?${queryString}`);

    yield put(ListPickingQuarentinesActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListPickingQuarentinesActions.failure(errorMessage));
  }
}
